import {useContext, useEffect, useMemo} from 'react'
import {useNavigate} from 'react-router-dom'
import {NavigationContext} from 'modules/dashboard/NavigationContext'
import {connectService} from 'components/service/connectService'
import { useConfirm } from 'hooks/useConfirm'
import { keys, pick } from 'lodash'
import { GroupPrototype, GroupSchema } from './schema'
import { useFormik } from 'formik'
import { ValidationError } from 'components/validation-error/ValidationError'
import { useNotification } from 'hooks/useNotification'

export const Group = connectService(
  props => {
    const confirm = useConfirm()
    const navigate = useNavigate()
    const notify = useNotification()

    const {setTitle} = useContext(NavigationContext)

    const {data, edit, onSave, remove} = props

    useEffect(() => {
      setTitle(data?.name)
    }, [data])

    const handleRemove = async () => {
      await remove(data._id).then(() => {
        navigate(-1)
      }).catch((e) => {
        notify({
          notification: e.message,
          variant: 'danger'
        })
      })
    }

    const initialData = useMemo(() => {
      return {...GroupPrototype, ...pick(data, keys(GroupPrototype))}
    }, [data, edit])

    const formik = useFormik({
      initialValues: edit
        ? initialData
        : { ...GroupPrototype },
      validationSchema: GroupSchema,
      onSubmit: async data => {
        await onSave({data})
        navigate(-1)
      },
      enableReinitialize: true
    })

    return (
      <>
        <div className="form-group row">
          <label className="col-sm-4 col-lg-5 col-form-label">Group Name</label>
          <div className="col-sm-8 col-lg-7">
            <input
              type="text"
              className="form-control"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            <ValidationError formik={formik} property="name" />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-4 col-lg-5 col-form-label">Rotation interval</label>
          <div className="col-sm-8 col-lg-7">
            <input
              type="number"
              className="form-control"
              name="rotationInterval"
              value={formik.values.rotationInterval}
              onChange={formik.handleChange}
            />
            <ValidationError formik={formik} property="rotationInterval" />
          </div>
        </div>
        <div className="vw-popup-box__inner__body__btns">
          <button className="btn btn-primary" onClick={formik.handleSubmit}>
            Save Group
          </button>
          {edit && (
            <button
              className="btn btn-danger"
              onClick={() => {
                confirm({
                  title: `Are you sure?`,
                  message: `Are you sure you want to remove the group ${data.name}? It contains ${data.statistics.devices} Devices & ${data.statistics.remotes} Remote Users. Once deleted, all the devices will automatically exit the group!`,
                  onConfirm: handleRemove
                })
              }}
            >
              Remove Group
            </button>
          )}
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            Cancel
          </button>
        </div>
      </>
    )
  },
  'group',
)
